import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/ResponsiveImage';
import Link from 'components/Link';
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton';
import PoorText from 'components/PoorText';
import { breakpoints } from 'js/breakpoints';

import './CountryPageTextCtaImageBlock.scss';

const CountryPageTextCtaImageBlock = ({
  heading,
  introHtml,
  image,
  ctaButton,
}) => {
  return (
    <div className="country-page-text-cta-image-block">
      <div className="country-page-text-cta-image-block__image-contaner">
        {image && (
          <ResponsiveImage
            {...image}
            loading="lazy"
            className="responsive-image_size_country-page-text-cta-image-block"
            sources={[
              {
                width: 390,
                height: 220,
                media: breakpoints.xs,
              },
              {
                width: 712,
                height: 400,
                media: breakpoints.s,
              },
              {
                width: 634,
                height: 356,
                media: breakpoints.m,
              },
            ]}
          />
        )}
      </div>
      <div className="country-page-text-cta-image-block__text-contaner">
        {heading && (
          <h2 className="country-page-text-cta-image-block__heading">
            {heading}
          </h2>
        )}
        {introHtml && (
          <PoorText
            className="country-page-text-cta-image-block__intro poor-text_in-country-page-text-cta-image-block"
            text={introHtml}
          />
        )}
        {ctaButton && (
          <div className="country-page-text-cta-image-block__cta-button-holder">
            <LinkButton
              {...ctaButton}
              theme={LINK_BUTTON_THEMES.dark}
              className="country-page-text-cta-image-block__cta-button"
            />
          </div>
        )}
      </div>
    </div>
  );
};

CountryPageTextCtaImageBlock.propTypes = {
  heading: PropTypes.string,
  introHtml: PropTypes.string,
  image: PropTypes.exact(ResponsiveImage.propTypes),
  ctaButton: PropTypes.exact(Link.propTypes),
};

export default CountryPageTextCtaImageBlock;
